import React from 'react'

import { pollCopyUrl } from '../../urls'

import CopyWithTooltip from './CopyWithTooltip'

const CopyPollUrl = ({ poll, children }) => {
  return (
    <CopyWithTooltip
      text={pollCopyUrl(poll)}
      labelBefore={'Copy poll URL to clipboard'}
      labelAfter={'Poll URL copied to clipboard'}
    >
      {children}
    </CopyWithTooltip>
  )
}

export default CopyPollUrl



// WEBPACK FOOTER //
// ./src/components/polls/CopyPollUrl.js